module.exports = __webpack_public_path__ + "static/media/Workshop_Inteligencia_Competitiva.07168746.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Workshop_Inteligencia_Competitiva.png
// module id = 45
// module chunks = 0